import { Anchor,Affix,Dropdown,Menu } from "ant-design-vue"
const { Link }  = Anchor;
import { mapState } from 'vuex'
import { jump,http,user } from '@utils'
import { portalApi } from '@utils/api'
import { enterInfo } from '@mixins'
const { Item,Divider,SubMenu }  = Menu;

export default {
    mixins:[enterInfo],
    components:{Anchor,Link,Affix,Dropdown,Menu,Item,Divider,SubMenu},
    props:{
        changeBg:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            isChangeHeader:false,
            userMenus:[],
            isShow: false
        }
    },
    created(){
        this.isChangeHeader = !this.changeBg;
        if(user.id){
            this.getUserMenu()
        }
    },
    mounted(){
        this.$nextTick(()=>{
            if(this.changeBg) {
                document.addEventListener('scroll',this.bindScroll);
            }
        })
    },
    beforeDestroy(){
        if(this.changeBg) {
            document.removeEventListener('scroll',this.bindScroll)
        }
    },
    methods:{
        goMobile() {
            let routerJump = this.$router.resolve({name: 'mobile'})
            window.open(routerJump.href, '_blank')
        },
        login(){
            jump.login()
        },
        async getUserMenu(){
            const response = await http.get(portalApi.getPortalMenu,{
                credentials: 'include',
                withCredentials: true,
            });
            try {
                if(response && response.data && response.data[0].children && response.data[0].children[0].children) {
                    this.userMenus = response.data[0].children[0].children;
                }
            } catch (e){

            }
        },
        menuItemClick(url){
            location.href = url;
        },
        bindScroll(){
            const top = window.pageYOffset || document.documentElement.scrollTop;
            if(top > 72) {
                this.isChangeHeader = true;
            } else {
                this.isChangeHeader = false;
            }
        },
        register(){
            jump.register();
        },
        toBind(){
            jump.accountBindCode();
        },
        toHome(){
            jump.home();
        },
        logout(){
            jump.logout();
        },
        workbench(){
            if(this.$route.name == 'enterManage' && this.BIND){
                jump.logout('workbench');
            } else {
                jump.workbench();
            }       
        },
        accoutManage(){
            jump.accoutManage();
        },
        safeManage(){
            jump.safeManage();
        },
        handleClick (e, link) {
            e.preventDefault();
            const {href} = link;
            if(!document.querySelector(href)){
                this.$store.commit('pages/home/scrollToId',href);
                jump.home()
            }
        },
        openMenu(openKeys) {
            const index = openKeys.length > 0 ? openKeys[0] : -1
            if (index >= 0) {
                const current = this.Anchor[index]
                if (current && current.children.length > 0) {
                    this.isShow = true
                    // setTimeout(() => {
                    //     const el = document.querySelector(`.main-sub-menu_${index}`)
                    //     el.style.left = (el.style.left.replace('px', '') - 40) + 'px'
                    //     console.log(el.style.left)
                    // }, 0);
                }
            } else {
                this.isShow = false
            }
        }
    },
    computed:{
        ...mapState({
            Anchor:state => state.pages.home.Anchor,
            userInfo:'userInfo'
        }),
        showbindBtn(){
            return (this.userInfo && !this.BIND && this.$route.name != 'accountBindCode' ) || !this.userInfo;
        }
        
    }
}
